import React from 'react';

const useScrollToView = (): [
  (ref: React.RefObject<HTMLElement | null>, verticalAlign?: ScrollLogicalPosition) => void
] => {
  const scrollToView = (
    ref: React.RefObject<HTMLElement | null>,
    verticalAlign?: ScrollLogicalPosition
  ): void => {
    if (!ref.current) return;

    ref.current.scrollIntoView({ behavior: 'smooth', block: verticalAlign || 'start' });
  };

  return [scrollToView];
};

export default useScrollToView;
